import React from 'react'

const redirectFormPage = () => {
  const url = 'https://forms.gle/G8w5wkgDEGhdaum28'
  window.open(url, '_blank')
}

const NoticeBar = () => {
  return (
    <div className='arcm-w-full arcm-bg-[#FFF7ED] arcm-border-b arcm-border-gray-200 arcm-mb-[20px]'>
      <div className='arcm-max-w-screen-xl arcm-mx-auto arcm-px-4 arcm-py-2'>
        <div className='arcm-flex arcm-items-center arcm-justify-center arcm-gap-2 arcm-text-sm arcm-text-gray-700'>
          <svg
            width='14'
            height='16'
            viewBox='0 0 14 16'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              fill-rule='evenodd'
              clip-rule='evenodd'
              d='M4.6041 1.71054C3.81461 1.42098 3.00969 1.57733 2.52341 1.94068C2.28459 2.11913 2.13808 2.33424 2.08207 2.55626C2.02776 2.77155 2.04523 3.04459 2.22521 3.37468C2.45071 3.78824 2.90738 4.0215 3.67548 4.1196C4.28424 4.19735 4.97047 4.17746 5.70174 4.15625L5.70187 4.15625L5.70635 4.15612C5.85089 4.15193 5.99719 4.1477 6.14502 4.14416C6.07336 3.21083 5.76411 2.13601 4.6041 1.71054ZM1.24123 3.9112C0.942468 3.36326 0.86418 2.80217 0.995367 2.28212C1.12486 1.7688 1.44511 1.34735 1.85257 1.04288C2.65885 0.440424 3.8646 0.245556 4.99005 0.658342C5.85077 0.974043 6.38854 1.52073 6.72461 2.1213C7.06067 1.52073 7.59845 0.974043 8.45917 0.658342C9.58462 0.245556 10.7904 0.440424 11.5967 1.04288C12.0041 1.34735 12.3243 1.7688 12.4539 2.28212C12.585 2.80217 12.5068 3.36326 12.208 3.9112C11.8437 4.57938 11.2378 4.92329 10.5843 5.10156H12.6307C13.0826 5.10156 13.449 5.4679 13.449 5.91979V7.27201C13.449 7.72389 13.0826 8.09023 12.6307 8.09023H7.28485V5.26485C7.23016 5.26348 7.17599 5.26225 7.12242 5.26119C6.98298 5.25844 6.8475 5.2254 6.72461 5.16742C6.60172 5.2254 6.46624 5.25844 6.3268 5.26119C6.27314 5.26225 6.21889 5.26349 6.1641 5.26486V8.09023H0.818227C0.366334 8.09023 0 7.72389 0 7.27201V5.91979C0 5.4679 0.366334 5.10156 0.818227 5.10156H2.86492C2.21141 4.92329 1.60556 4.57938 1.24123 3.9112ZM8.84515 1.71054C9.63461 1.42098 10.4395 1.57733 10.9258 1.94068C11.1646 2.11913 11.3112 2.33424 11.3671 2.55626C11.4214 2.77155 11.404 3.04459 11.224 3.37468C10.9985 3.78824 10.5418 4.0215 9.77373 4.1196C9.16495 4.19736 8.47862 4.17746 7.74738 4.15625L7.74734 4.15625L7.74286 4.15612C7.59832 4.15193 7.45203 4.1477 7.3042 4.14416C7.37585 3.21083 7.68511 2.13601 8.84515 1.71054ZM6.16401 9.21094H1.5653C1.1134 9.21094 0.74707 9.57727 0.74707 10.0292V13.924C0.74707 14.8277 1.47973 15.5604 2.38352 15.5604H6.16401V9.21094ZM7.28476 15.5604H11.0653C11.969 15.5604 12.7017 14.8277 12.7017 13.924V10.0292C12.7017 9.57727 12.3354 9.21094 11.8835 9.21094H7.28476V15.5604Z'
              fill='#F97316'
            />
          </svg>

          <span>Get an exclusive discount by sharing your feedback.</span>
          <button onClick={redirectFormPage} className='arcm-text-blue-600 arcm-font-medium hover:arcm-text-blue-700'>
            Click here
          </button>
        </div>
      </div>
    </div>
  )
}

export default NoticeBar
